import React from "react";
import "./Portfolio.css";
import IMG1 from "../../assets/overstock.png";
import IMG2 from "../../assets/zara.png";
import IMG3 from "../../assets/mynetdiary.png";
import IMG4 from "../../assets/purplle.png"
import IMG5 from "../../assets/weather.png"


const data = [
  {
    id: 1,
    image: IMG4,
    title: "Purplle",
    des: "an online platform to buy beauty and cosmetic products.",
    tech:" React ||Redux ||Chakra-ui ||bootstrap ",
    type:"Collaborative",
    github: "https://github.com/Ashmit-1131/deranged-bikes-7325",
    demo: " https://purplle-ashmit-1131.vercel.app"
  },
  {
    id: 2,
    image: IMG1,
    title: "Overstock",
    des: "an American internet retailer selling primarily furniture.",
    tech:" React ||Redux ||Chakra-ui ||bootstrap ",
    type:"Collaborative",
    github: "https://github.com/Ashmit-1131/sole-air-9197",
    demo: "https://overstockmasai.netlify.app/",
  },
  {
    id: 3,
    image: IMG2,
    title: "Zara",
    des: "ZARA is multi-national clothing chain.It specialises in fast fashion.",
    tech:" React ||Redux ||Chakra-ui ||bootstrap ",
    type:"Individual",
    github: "https://github.com/Ashmit-1131/Zara-Cloned-website",
    demo: "https://zara-beige.vercel.app/",
  },
  {
    id: 4,
    image: IMG3,
    title: "MyNetDiary",
    des: "MyNetDiary is a digital diet assistant for weight loss.Try MyNetDiary today!.",
    tech:" Html ||CSS ||Javascript ",
    type:"Collaborative",
    github: "https://github.com/Ashmit-1131/MyNetDiary.com",
    demo: "https://jazzy-scone-de755c.netlify.app/",
  },
  {
    id: 5,
    image: IMG5,
    title: "React-Weather-app",
    des: "It is weather app you can check weather of any city by entering it's name",
    tech:"React || tailwind css || Weather Api ",
    type:"Individual",
    github: "https://github.com/Ashmit-1131/react-weather-app",
    demo: "https://ash-weather-app.vercel.app/",
  }
  
  

];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div
        className="container 
      portfolio_container"
      >
        {data.map(({ id, image, title,des, github, demo,tech,type }) => {
          return (
            <article className="portfolio_item" key={id}>
              <div className="portfolio_item-image">
                <img src={image} alt={title} />
              </div>
              <div>
                <h6>{type}</h6>
                <h5>{tech}</h5></div>
              
              <h2>{title}</h2>
              <p>{des}</p>
             
              <div className="portfolio_item-cta">
                <a href={github} className="btn primary"
                 target="_blank"
                 rel="noreferrer">
                  Github
                </a>
                <a
                  href={demo}
                  className="btn white"
                  target="_blank"
                  rel="noreferrer"
                >
                Deployed
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;